import { alicorpTheme, diadiaTheme, insumaTheme } from '@pu/mpp-ui/themes';
import { EChannel } from 'core/model/enums/channel.enum';

export const getThemeByChannel = (channelId: EChannel) => {
  switch (channelId) {
    case EChannel.DIADIA:
      return diadiaTheme;
    case EChannel.INSUMA:
      return insumaTheme;
    default:
      return alicorpTheme;
  }
};
